module.exports = __webpack_public_path__ + "img/img_tutorial_swipe.6e569562.svg";